import LightweightCandles from "../Test1/LightweightCandles";

export default function MicroPage() {
  return (
    <div style={{ width: "100vw", height: "100vh", padding: 16, background: "#0b0b0c" }}>
      <LightweightCandles
        updateIntervalMs={2000}   // change la cadence ici
        rangeNormal={[25, 35]}    // plage “normale”
        rangeCrash={[5, 10]}      // plage en “crash”
        history={60}              // nombre de bougies d’historique au départ
        buffer={200}              // longueur max conservée
      />
    </div>
  );
}
